<template>
  <div class="annotation-style-controls">
    <div class="annotation-style-controls__colors">
      <button
        v-for="c in COLOR_PRESETS"
        :key="c"
        type="button"
        class="annotation-style-controls__swatch"
        :class="{ 'annotation-style-controls__swatch--active': activeStyle.color === c }"
        :style="{ backgroundColor: c }"
        @click="activeStyle = { ...activeStyle, color: c }"
      />
    </div>
    <label class="annotation-style-controls__slider-label">
      <span>Width</span>
      <div class="annotation-style-controls__slider">
        <fs-slider
          :model-value="activeStyle.strokeWidth"
          :min="1"
          :max="8"
          :interval="0.5"
          tooltip="none"
          @update:model-value="activeStyle = { ...activeStyle, strokeWidth: $event }"
        />
      </div>
    </label>
  </div>
</template>

<script setup lang="ts">
import type { AnnotationStyle } from '@/ApiClient';
import FsSlider from '@components/form-elements/fs-slider.vue';

const activeStyle = defineModel<AnnotationStyle>({ required: true });

const COLOR_PRESETS = ['#35495E', '#E74C3C', '#2ECC71', '#3498DB', '#F39C12', '#9B59B6'];
</script>

<style scoped lang="scss">
@import '@styles/variables';

.annotation-style-controls {
  display: flex;
  align-items: center;
  gap: 1.2rem;

  &__colors {
    display: flex;
    gap: 0.4rem;
  }

  &__swatch {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    border: 2px solid transparent;
    cursor: pointer;

    &--active {
      border-color: $c-dark;
      box-shadow: 0 0 0 1px white inset;
    }
  }

  &__slider-label {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    font-size: 1.2rem;
    color: $c-dark;
  }

  &__slider {
    width: 6rem;
  }
}
</style>
